'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownPurchasesyears extends Dropdown {
	constructor(component_key) {
		super(component_key);
	}
	add_events() {
		this.$selected.on('click', `.js-${this.id}_option`,
			this.selected_click_handler.bind(this)
		);
		this.$list.on('click', `.js-${this.id}_option`,
			this.option_click_handler.bind(this)
		);
		jQuery(`.js-${this.id}`).on('blur', this.close_all.bind(this));
	}
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		if ($element.data('selected')) {
			return;
		}
		const $selected = this.$selected.find(`.js-${this.id}_option`);
		$selected.remove();
		$element.clone().prependTo(this.$selected);
		this.close_all(event);
		this.$options.attr('data-selected', null);
		$element.attr('data-selected', 1);
		this.$options = this.$list.find(`.js-${this.id}_option`);
		yalwa.purchases.load_months($element.data('value'));
	}
}
